@if (field.sequentialView && isLanding) {
<div class="common-text-input__container-field-sequential">
  <field-sequential-header [field]="field"></field-sequential-header>
  <div class="common-radio-button-list__container-survey-sequential-option"
    [ngClass]="{'common-radio-button-list__container-survey-sequential-option--error': field.error}"
    (click)="selectOption(true)"
    [attr.disabled]="field.noEditable?true:null">
    <div class="common-button__block-button-md-checkbox">
      <button class="common-button__icon-md-checkbox"
        [ngClass]="{'common-button__icon-md-checkbox--selected': fieldTypeBool.preSelectItem === true}"
        [disabled]="field.noEditable">
        <i class="common-icon__md"
          [ngClass]="fieldTypeBool.preSelectItem === true?'lf-icon-radio-button-active': 'lf-icon-step-first'"></i>
      </button>
    </div>
    <div class="common-radio-button-list__container-survey-sequential-option-text">
      <span class="common-radio-button-list__text-input-survey-sequential-option"
        [afTranslate]="'common.yes'">Si
      </span>
      @if (field.withColor) {
        <div class="common-badge__block-dot-md">
          <div [ngClass]="{'common-badge__dot-md-empty-grey': fieldTypeBool.preSelectItem !== true,
            'common-badge__dot-md-green': (fieldTypeBool.preSelectItem && field.withColor === 1),
            'common-badge__dot-md-red': (fieldTypeBool.preSelectItem && field.withColor === 2)}">
          </div>
        </div>
      }
    </div>
  </div>
  <div class="common-radio-button-list__container-survey-sequential-option"
    [ngClass]="{'common-radio-button-list__container-survey-sequential-option--error': field.error}"
    (click)="selectOption(false)"
    [attr.disabled]="field.noEditable?true:null">
    <div class="common-button__block-button-md-checkbox">
      <button class="common-button__icon-md-checkbox"
        [ngClass]="{'common-button__icon-md-checkbox--selected': fieldTypeBool.preSelectItem === false}"
        [disabled]="field.noEditable">
        <i class="common-icon__md"
          [ngClass]="fieldTypeBool.preSelectItem === false?'lf-icon-radio-button-active': 'lf-icon-step-first'"></i>
      </button>
    </div>
    <div class="common-radio-button-list__container-survey-sequential-option-text">
      <span class="common-radio-button-list__text-input-survey-sequential-option"
        [afTranslate]="'common.no'">No
      </span>
      @if (field.withColor) {
        <div class="common-badge__block-dot-md">
          <div [ngClass]="{'common-badge__dot-md-empty-grey': fieldTypeBool.preSelectItem !== false,
            'common-badge__dot-md-green': (fieldTypeBool.preSelectItem === false && field.withColor === 2),
            'common-badge__dot-md-red': (fieldTypeBool.preSelectItem === false && field.withColor === 1)}">
          </div>
        </div>
      }
    </div>
  </div>
  @if (field.error) {
    <div class="common-text-input__mandatory-tag">
      @if (field.blocker) {
        <i class="lf-icon-warning common-icon__error-md"></i>
      }
      <span [afTranslate]="field.blocker? 'common.field-mandatory-blocking' : 'common.field-mandatory'">
        Campo obligatorio
      </span>
    </div>
  }
</div>
}@else {
  <div class="common-bool-input__input">
    <div class="common-bool-input__element"
      [ngClass]="{ 'common-bool-input__element-highlight': field.isHighlight,
        'common-bool-input__element-required': field.error }"
      [attr.disabled]="field.noEditable?true:null">
      <div class="common-bool-input__container">
        <div class="common-bool-input__text-container">
          <span class="common-bool-input__text-label">
            {{fieldTypeBool.titleField}}
          </span>
          @if (field.required) {
            <span class="common-bool-input__required-asterisk">*</span>
          }
          <div class="common-text-input__block-buttons">
            @if (field.description) {
              <tooltip-info [description]="field.description"
              [field]="field"></tooltip-info>
            }
            @if (field.references?.length) {
              <tooltip-law [references]="field.references"
              [field]="field"></tooltip-law>
            }
            @if (field.relatedInfo && field.relatedInfo.length  && !field.poll && !field.noEditable) {
              <button class="common-button__icon-sm-noborder"
                pTooltip="{{'common.related-info'| afTranslate}}"
                tooltipPosition="top"
                (click)="openModalRelatedInfo(field.relatedInfo, $event)">
                <i class="lf-icon-search-text common-icon__md"></i>
              </button>
            }
            @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
              <tooltip-in-report [inReport]="fieldTypeBool.inReport"></tooltip-in-report>
            }
          </div>
        </div>
        <div [ngClass]="{'common-bool-input__buttons-container--center': !field.withColor }"
          class="common-bool-input__buttons-container">
          <div class="common-button__body-decision-button">
            <button
              (click)="selectOption(true)"
              [disabled]="field.noEditable"
                          [ngClass]="{
                              'common-button__decision-button--selected': fieldTypeBool.preSelectItem
                          }"
              class="common-button__decision-button">
              <span
                [afTranslate]="'common.yes'"
              class="common-button__decision-button-label-text">Si</span>
            </button>
            <button
              (click)="selectOption(false)"
              [disabled]="field.noEditable"
                          [ngClass]="{
                              'common-button__decision-button--selected': fieldTypeBool.preSelectItem === false
                          }"
              class="common-button__decision-button">
              <span
                [afTranslate]="'common.no'"
              class="common-button__decision-button-label-text">No</span>
            </button>
          </div>
          @if (field.withColor) {
            <div class="common-badge__block-dot-md">
              <div [ngClass]="{'common-badge__dot-md-empty-grey': fieldTypeBool.preSelectItem !== false && fieldTypeBool.preSelectItem !== true,
                  'common-badge__dot-md-green': (fieldTypeBool.preSelectItem && field.withColor === 1) || (fieldTypeBool.preSelectItem === false && field.withColor === 2),
                  'common-badge__dot-md-red': (fieldTypeBool.preSelectItem && field.withColor === 2) || (fieldTypeBool.preSelectItem === false && field.withColor === 1)}">
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    @if (field.error) {
      <div class="common-text-input__mandatory-tag">
        @if (field.blocker) {
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        <span [afTranslate]="field.blocker? 'common.field-mandatory-blocking' : 'common.field-mandatory'">
          Campo obligatorio
        </span>
      </div>
    }
  </div>
}
